import { UiLocaleProvider } from "@nabble/ui";
import { createElement, type ComponentType } from "react";
export function financeLocale(Component: ComponentType): ComponentType {
  return function FinanceRoute(): React.JSX.Element {
    return <UiLocaleProvider locale="es"><div lang="es">{createElement(Component)}</div></UiLocaleProvider>;
  };
}
